import SectionHeader from './SectionHeader';

export default function CertificationsSection({ data, template, accent }) {
  if (!data.certifications || data.certifications.length === 0) return null;

  return (
    <div className="resume-section">
      <SectionHeader template={template} accent={accent}>Certifications &amp; Licenses</SectionHeader>
      <div style={{ fontFamily: template.bodyFont, fontSize: '10.5pt', color: '#1c1c1c', lineHeight: 1.5 }}>
        <ul style={{ margin: 0, paddingLeft: '0.22in' }}>
          {data.certifications.map((c, i) => (
            <li key={i} style={{ marginBottom: '0.03in' }}>
              <span style={{ fontWeight: 600 }}>{c.name}</span>
              {c.org && <span>{', '}{c.org}</span>}
              {c.date && <span style={{ color: '#3a3a3a' }}>{' ('}{c.date}{')'}</span>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
